import SharedDeleteModal from "../../../../components/UI/SharedDeleteModal";

const DeleteUserModal = (props) => (
  <SharedDeleteModal
    {...props}
    titleKey="user_delete_confirmation"
    descriptionKey="user_delete_description"
  />
);

export default DeleteUserModal;
